export const serviceTypeColumns = [
  {
    title: 'Service Type',
    key: 'title',
    dataIndex: 'title'
  }
];
